<template>
  <div class="product-detail">
    <v-row justify="center">
      <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex">
        <v-card elevation="0" class="mx-auto" width="80" height="85">
          <div
            v-for="(picture, i) in product.productImages"
            :key="i"
            id="over"
            :class="{ borde: i == indexOfActive ? false : true }"
          >
            <div class="imgContainer">
              <v-img
                contain
                :src="viewImage(picture.image)"
                @mouseover="changeActiveImg(i)"
                class="img"
                :class="{ active: i == indexOfActive ? true : false }"
              />
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col lg="7" md="7" sm="11" class="d-none d-sm-flex">
        <v-card class="mx-auto" width="420" elevation="0">
          <div class="image-container">
            <v-img
              :src="activeImg"
              class="image1 primary--text align-end"
              contain
            >
            </v-img>
          </div>

          <v-col class="pa-0" cols="12" v-if="showSimilar">
            <childSimilar
              :products="similarProducts"
              :similar="showSimilar"
              :sendSnack="sendSnack"
            >
            </childSimilar>
          </v-col>
        </v-card>
      </v-col>

      <v-col sm="12" xs="12" class="d-flex d-sm-none">
        <div class="image-container1">
          <v-carousel
            :show-arrows="false"
            hide-delimiters
            height="400"
            v-if="product.productImages.length >= 1"
          >
            <v-carousel-item
              v-for="(picture, i) in product.productImages"
              :key="i"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <v-sheet color="white" height="100%" width="100%" class="mx-auto">
                <v-card width="500" color="white" elevation="0">
                  <div class="image-container2">
                    <v-img
                      :src="viewImage(picture.image)"
                      class="image2"
                      aspect-ratio="1"
                      contain
                    >
                      <v-badge color="#F5F5F5" offset-x="-5">
                        <span slot="badge" class="txtColor">
                          {{ i + 1 }} / {{ product.productImages.length }}
                        </span>
                      </v-badge>
                    </v-img>
                  </div>
                </v-card>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>

          <v-card width="500" color="white" elevation="0" v-else>
            <div class="image-container2">
              <v-img :src="activeImg" class="image2" contain aspect-ratio="1">
              </v-img>
            </div>
          </v-card>
        </div>
      </v-col>

      <v-col lg="4" md="4" sm="12" xs="12">
        <v-card class="pa-5" min-height="450px" min-width="320px">
          <v-row>
            <v-col class="pa-0" lg="12" md="12" sm="12" xs="12">
              <p>
                <strong class="primary--text">{{ product.description }}</strong>
              </p>
            </v-col>

            <v-col class="pa-0 my-n3" cols="12">
              <p>{{ brandName }}</p>
            </v-col>
          </v-row>

          <v-row v-if="product.obsoleto == 1">
            <v-col class="pa-0" cols="12">
              <h4 class="red--text accent-4">Obsoleto</h4>
            </v-col>
          </v-row>

          <v-row class="pt-3 my-5">
            <v-col class="pa-0 my-n4" lg="6" md="5" sm="4" xs="6">
              <div class="counterText">
                <!-- TextField cantidad -->
                <v-text-field
                  v-if="!selectVisible"
                  hide-details
                  @blur="updateLocalStorage(product.quantity)"
                  @keypress="allowOnlyNumbers"
                  class="order-cant"
                  v-model="product.quantity"
                  :value="product.quantity"
                  dense
                  label="Cantidad"
                  outlined
                  type="text"
                >
                </v-text-field>

                <v-select
                  label="Cantidad"
                  outlined
                  v-if="selectVisible"
                  hide-details
                  dense
                  v-model="product.quantity"
                  :items="cantidad"
                  @change="updateLocalStorage(product.quantity)"
                >
                </v-select>
              </div>
            </v-col>

            <v-col lg="6" md="5" sm="6" xs="12" class="my-n6">
              <childBtnExistencias
                class="texto"
                :sendSnack="sendSnack"
                :itemId="product.itemId"
                :key="product.itemId"
              >
              </childBtnExistencias>
            </v-col>

            <v-col class="pa-0 my-4" cols="12">
              <h6 class="orange--text darken-3">*Stock salvo previa venta</h6>
            </v-col>

            <v-col class="pa-0" cols="12">
              <p class="primary--text">
                <strong>¡Cotiza ahora!</strong>
              </p>
            </v-col>

            <v-col lg="12" md="12" sm="12" xs="12">
              <div class="text-center">
                <v-btn
                  x-large
                  elevation="10"
                  class="white--text"
                  color="orange darken-3"
                  @click="addShoppingCart()"
                >
                  <div class="text-md-h4">Agregar a mi lista</div>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import childSimilar from "./child_similarProducts.vue";
import childBtnExistencias from "./../child_btn_existencias.vue";
import childBtnPrecio from "./../child_btn_precio.vue";
import {
  addProductCart,
  removeProductCart,
  updateProductCart,
} from "./../../utils/shoppingCart";

export default {
  name: "child_productDetail",

  components: {
    childSimilar,
    childBtnExistencias,
    childBtnPrecio,
  },

  data() {
    return {
      selectVisible: true,
      indexOfActive: 0,
      clientId: "",
      showPriceBtn: false,
      session: false,
      characteristics: "",
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/",
      activeImg: "",
      cantidad: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10+", value: 10 },
      ],
    };
  },

  props: {
    product: { type: Object },
    sendSnack: { type: Function },
    updateShopingQuantity: { type: Function },
    similarProducts: { type: Array },
    showSimilar: { type: Boolean },
  },

  methods: {
    viewImage: function (name = "") {
      var url = this.url + name;
      return url;
    },

    changeActiveImg: function (index) {
      this.activeImg = this.url + this.product.productImages[index].image;
      this.indexOfActive = index;
      return this.activeImg;
    },

    increase: function () {
      this.product.quantity++;
      this.$forceUpdate();
    },

    decrease: function () {
      if (this.product.quantity > 0) {
        this.product.quantity--;
        this.$forceUpdate();
      }
    },

    addShoppingCart: function () {
      var item = this.product;
      var producto = {
        id: item.id,
        image: item.image,
        description: item.description,
        itemId: item.itemId,
        code: item.code,
        unit: item.unit,
        providerCode: item.providerCode,
        quantity: item.quantity,
        characteristics: this.characteristics,
      };

      if (item.quantity > 0) {
        addProductCart(producto);
        this.product.quantity = 1;
        this.sendSnack("Producto agregado con éxito");
      } else {
        this.product.quantity = 1;
        this.sendSnack(
          "Debes ingresar al menos 1 producto al carrito de compras"
        );
      }

      this.updateShopingQuantity();
    },

    allowOnlyNumbers(event) {
      const key = event.key;
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    },

    updateLocalStorage: function (cantidad) {
      var vm = this;
      vm.product.quantity = Number(cantidad);
      if (cantidad == 10) {
        vm.product.quantity = 10;
        vm.selectVisible = false;
      }
      if (cantidad > 0 && cantidad < 10) {
        vm.selectVisible = true;
      }
    },

    removeShoppingCart: function (item) {
      removeProductCart(item.id);
    },

    updateProductCart: function (item) {
      var producto = {
        id: item.id,
        quantity: item.quantity,
      };
      updateProductCart(producto);
    },

    image: function () {
      var image = this.product.image;
      var url = this.url + image;
      return url;
    },

    characteristicsValues() {
      this.product.characteristicValues.map((characteristic, index) => {
        if (index == 0) this.characteristics = ` ${characteristic.value}`;
        else
          this.characteristics = `${this.characteristics}, ${characteristic.value}`;
      });
    },
  },

  computed: {
    quantity() {
      return this.product.quantity;
    },

    characteristic() {
      return this.characteristics;
    },

    brandName() {
      return !!this.product.brand ? this.product.brand.name : "";
    },
  },

  watch: {},

  created() {
    if (localStorage.clientId) this.clientId = localStorage.getItem("clientId");
    this.showPriceBtn =
      this.clientId == "null" ||
      this.clientId == "undefined" ||
      this.clientId == ""
        ? false
        : true;

    this.activeImg = this.url + this.product.image;
    this.product.quantity = 1;
  },

  mounted() {
    var vm = this;
    vm.selectVisible = vm.product.quantity < 10;
  },

  beforeUpdate() {
    this.characteristicsValues();
  },
};
</script>

<style scoped>
.product-detail {
  font-size: 2rem;
  min-height: 510px;
}

.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 80px;
  height: 83px;
}

.img {
  height: 81px;
  width: auto;
  max-width: 79px;
  border-radius: 7px;
}

.borde {
  width: 85px;
  border: 2px solid rgba(235, 235, 238, 0.719);
  margin-bottom: 5px;
  border-radius: 10px;
}

.active {
  border: 3px solid rgb(15, 84, 175);
  border-radius: 5px;
  margin-left: 15px;
  margin-bottom: 5px;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 420px;
  height: 400px;
}

.image1 {
  height: 100%;
  width: auto;
  max-width: 400px;
}

.image-container2 {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 550px;
  height: 400px;
}

.image2 {
  height: 100%;
  width: auto;
  max-width: 550px;
}

.image-container1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 387px;
}

.txtColor {
  color: blue;
  font-size: small;
}

.centered-input ::v-deep input {
  text-align: center;
}
.texto {
  font-size: 15px;
}
</style>
